import { Injectable } from '@angular/core'
import { Observable, BehaviorSubject, catchError } from 'rxjs'
import { HttpClient } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class TransactionsServices extends BehaviorSubject<any[]> {
  constructor(private _http: HttpClient) {
    super([])
  }

  checkfiles(br: any): Observable<any> {
    return this._http
      .post<any[]>('/api/Blotter/checkfiles', br)
      .pipe(catchError(this.handleError))
  }

  RemoveEmailRecordupload(r: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Blotter/removeEmailRecord`, r)
      .pipe(catchError(this.handleError))
  }

  getPendingTransactionList(params: any): Observable<object[]> {
    const url = `/api/Transactions/GetPendingTransactionsForView`
    return this._http
      .post<any[]>(url, params)
      .pipe(catchError(this.handleError))
  }

  getbookmarks(): Observable<object[]> {
    const url = `/api/Transactions/GetBookmarkedPendingTransactionsByUserId`
    return this._http.get<any[]>(url).pipe(catchError(this.handleError))
  }

  UpdatependingStats(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Blotter/UpdatePendingStatus`, r)
      .pipe(catchError(this.handleError))
  }

  ChangeTransactionTypesNewTypes(r: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Transactions/reviseTransaction`, r)
      .pipe(catchError(this.handleError))
  }

  GetTransactionformlist(r: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Transactions/getFormList`, r)
      .pipe(catchError(this.handleError))
  }

  ReviseTransactionlist(r: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Transactions/reviseTransaction`, r)
      .pipe(catchError(this.handleError))
  }

  GetTransactionEditListing(r: any): Observable<object[]> {
    return this._http
      .post<any[]>(`/api/Transactions/editTrans`, r)
      .pipe(catchError(this.handleError))
  }

  getTransactionBranchNumbers(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Transactions/GetTransactionBranches`, r)
      .pipe(catchError(this.handleError))
  }

  getTransactionReps(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Transactions/GetTransactionReps`, r)
      .pipe(catchError(this.handleError))
  }

  getTransactionStatuses(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Transactions/GetTransactionStatuses`, r)
      .pipe(catchError(this.handleError))
  }

  getTransactionResults(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Transactions/GetTransactionResults`, r)
      .pipe(catchError(this.handleError))
  }
   getTransactionPendingAlertsResults(r: any): Observable<any[]> {
    return this._http
      .post<any[]>(`/api/Transactions/GetPageResultsTransactionResults`, r)
      .pipe(catchError(this.handleError))
  }
//page
  getTransactionDetails(r: any): Observable<any> {
    return this._http
      .post<any>(`/api/Transactions/GetTransactionDetails`, r)
      .pipe(catchError(this.handleError))
  }

  getHiddenColumns(): Observable<string[]> {
    return this._http
      .get<string[]>(`/api/Transactions/GetHiddenColumns`)
      .pipe(catchError(this.handleError))
  }

  getCurrentRole(): Observable<any> {
    return this._http
      .get(`/settings/GetCurrentRole`, { responseType: 'text' })

      .pipe(catchError(this.handleError))
  }
  getDeletedTransactions(): Observable<any[]> {
    return this._http
      .get<any[]>(`/api/Transactions/GetDeletedTransactions`)
      .pipe(catchError(this.handleError))
  }

  PostBookMarks(u: any): Observable<object> {
    return this._http
      .post<object>('/api/BookMarks/savebookmark', u)
      .pipe(catchError(this.handleError))
  }

  PostBookMarksRemove(u: any): Observable<object> {
    return this._http
      .post<object>('/api/BookMarks/removebookmark', u)
      .pipe(catchError(this.handleError))
  }

  GetReviewquestions(r: any): Observable<object> {
    return this._http
      .post<object>('/api/Reviews/getreviews', r)
      .pipe(catchError(this.handleError))
  }

  GetNewAccountFormReviewQuestions(r: any): Observable<object> {
    return this._http
      .post<object>('/api/Reviews/accountformreviews', r)
      .pipe(catchError(this.handleError))
  }

  restoreTransaction(blotterId: number) {
    return this._http
      .post(`/api/Transactions/RestoreTransaction`, blotterId)
      .pipe(catchError(this.handleError))
  }

  private handleError(error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    return Promise.reject(errMsg)
  }
}
